/**

@ngdoc directive
@name termsList

@description
it displays terms / tags list
if listed param not set the directive will operate directly on data once term/tag is removed (!)

@param {string} title list header
@param {Object} data data object.<br />
                available formats: {key: value, key: value} or {key: {prop1: value, otherProperty:etc}, key: {prop1: value, otherProperty:etc} }<br />
                in second case showDataProperty needs to be specified
@param {string=} showDataProperty specifies which property of object will be display as a term / tag name
@param {string=} listed specifies which data keys will be shown. if not present the directive will operate directly on data if term/tag is removed!

@example
please refer to testUi (former testValidation) > Extras

*/

(function() {

var termsList = function($timeout, $templateCache) {
    return {
        restrict: "E",
        scope: {
            title: "@",
            data: "&",
            showDataProperty: '@', // (optional)
            listed: "=",
            ngReadonly: "="
        },
        replace:true,
        template: $templateCache.get('components/listing/termsList.html'),
        link: function (scope, element, attrs, ctrls) {

            $timeout(function(){
                if( angular.isArray(scope.data()) ){
                    scope.isSimpleArray = true;
                }
            });

            scope.removeTerm = function(id, e){
                e.preventDefault();
                if(angular.isDefined(scope.listed)){
                    // removes from listed if it's defined
                    scope.listed[id] = false;
                } else {
                    // or from data array/object in other case
                    if( angular.isArray(scope.data()) ){
                        scope.data().splice(id, 1);
                    } else {
                        delete scope.data()[id];
                    }
                }
            }

            scope.emptyListing = function(){
                var val = true;
                angular.forEach(scope.listed, function(value,key){
                    if(value==true){
                        val = false;
                    }
                });
                return val;
            }

        }
    }
}
termsList.$inject = ['$timeout', '$templateCache'];
angular.module('app').directive('termsList', termsList);

}());